import axios from "axios";

const state = {
  claims:[],
  pagination: {}
};

const mutations = {
  SET_CLAIMS: (state,claims) => {
    state.claims = claims
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination
  },
};

const actions = {
  async GET_CLAIMS(context, data){
    try {
      const  response = await axios.get('/foodcourt/claims/?page=' + data.page,{
        params: data
      })
      context.commit('SET_CLAIMS',response.data.payload.result.data)
      context.commit('SET_PAGINATION', {
        page: response.data.payload.result.current_page,
        first_page_url: response.data.payload.result.first_page_url,
        from: response.data.payload.result.from,
        last_page: response.data.payload.result.last_page,

        last_page_url: response.data.payload.result.last_page_url,
        next_page_url: response.data.payload.result.next_page_url,
        path: response.data.payload.result.path,
        rowsPerPage: response.data.payload.result.per_page,
        prev_page_url: response.data.payload.result.prev_page_url,
        to: response.data.payload.result.to,
        totalItems: response.data.payload.result.total,
      })
    }catch (e) {
      console.log(e)
    }
  }
};

export default {
  namespaced:true,
  state,
  mutations,
  actions
}
